import React, { useState } from 'react'
import TransportAssignModal from './TransportAssignModal';

const TransportAssignModalButton = ({assigned_technicianid,transport_user_id,fetchData,fetchTicketData}) => {
    const [isModalOpen, setModalOpen] = useState(false);


    const openModal = () => {
      setModalOpen(true);
    };
  
    const closeModal = () => {
      setModalOpen(false);
    };



  return (
    <div>
        <div className='flex'>
              <button
                  onClick={() => openModal()}
                  className='bg-[#FA6669] rounded-[4px] px-[16px] py-[5px] text-[#fff]'
                  >
                    Assign
              </button>
        </div>

          <TransportAssignModal
                isOpen={isModalOpen}
                onClose={closeModal}
                setModalOpen={setModalOpen}
                assigned_technicianid ={assigned_technicianid}
                transport_user_id = {transport_user_id}
                fetchData={fetchData}
                fetchTicketData={fetchTicketData}
            />
    </div>
  )
}

export default TransportAssignModalButton